// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3NKZZ","log":"ModalInventoryLogs_log__1ca5O","date":"ModalInventoryLogs_date__3shWy","userName":"ModalInventoryLogs_userName__32mtg"};